import { useState } from 'react';
import { cn } from '@/lib/utils/cn';
import { PERSONAS, type TutorialPersona } from '../data/tutorial-data';

interface PersonaSwitcherProps {
  personas: string[];
  children: (activePersona: string) => React.ReactNode;
}

export function PersonaSwitcher({ personas, children }: PersonaSwitcherProps) {
  const [active, setActive] = useState(personas[0]);

  return (
    <div className="space-y-4">
      {/* Tabs */}
      <div className="flex gap-1 p-1 bg-muted rounded-lg w-fit">
        {personas.map((id) => {
          const persona = PERSONAS[id] as TutorialPersona;
          return (
            <button
              key={id}
              onClick={() => setActive(id)}
              className={cn(
                'flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all',
                active === id
                  ? 'bg-background shadow-sm text-foreground'
                  : 'text-muted-foreground hover:text-foreground'
              )}
            >
              <div
                className={cn(
                  'w-6 h-6 rounded-full flex items-center justify-center text-white text-[10px] font-bold',
                  persona.color
                )}
              >
                {persona.initials}
              </div>
              {persona.name}
            </button>
          );
        })}
      </div>

      {/* Content */}
      <div>{children(active)}</div>
    </div>
  );
}
